import React from 'react';
import FormRow from "v4/components/form/FormRender/components/FormRow/FormRow";
import PolColumns from "v4/components/utils/PolColumns/PolColumns";
import FormRender from "v4/components/form/FormRender/FormRender";

export default function ModuleStatisticsRenderBlockForm({form, formId, formErrors, onSubmit}) {
    return (
        <FormRender form={form}
                    formId={formId}
                    formErrors={formErrors}
                    onSubmit={onSubmit}
                    hasToHideRest>
            <FormRow fieldName="statistic_block_configuration[label]"/>
            <FormRow fieldName="statistic_block_configuration[blockConfiguration][unit]"/>
            <FormRow fieldName="statistic_block_configuration[blockConfiguration][quoteStateIds]"/>
            <PolColumns cols={3}>
                <FormRow fieldName="statistic_block_configuration[blockConfiguration][operation]"/>
                <FormRow fieldName="statistic_block_configuration[blockConfiguration][operationField]"/>
                <FormRow fieldName="statistic_block_configuration[blockConfiguration][secondOperationField]"/>
            </PolColumns>
            <FormRow fieldName="statistic_block_configuration[blockConfiguration][groupingField]"/>
            <PolColumns cols={2}>
                <FormRow fieldName="statistic_block_configuration[displayListing]"/>
                <FormRow fieldName="statistic_block_configuration[displaySheet]"/>
            </PolColumns>
        </FormRender>
    )
}
